import apiFetch from '../../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `RegistroAlimentacion/obtenerNumeroRegistroAlimentacion`, method: 'GET', body: null, token: token})
}